<template>
  <div class="periodic">
    <div class="">
      {{ $t("point.periodic") }}
      <em
        class="fas fa-edit edit"
        size="mini"
        @click="showEditForm()"
        v-show="!editing"
      ></em>
    </div>
    <div class="body" v-loading="loading">
      <div v-if="!point.periodic" style="text-align: center" class="info">
        {{ $t("point.NoPeriodicFound") }}
      </div>

      <ul v-if="point.periodic && !editing">
        <li>
          <span style="font-size: 10px; color: rgb(128, 128, 128)">{{
            $t("point.sleepAmount")
          }}</span>
          <br />
          <span>{{
            $t(`sleepAmount.${point.periodic.sleepAmount.friendly}`)
          }}</span>
        </li>
        <li v-if="point.schedulerJob">
          <span style="font-size: 10px; color: rgb(128, 128, 128)">{{
            $t("point.nextRun")
          }}</span>
          <br />
          <span
            >~{{ formatDate(point.schedulerJob.nextRunAt, "future") }}
            {{ $t("common.minute") }} {{ $t("common.after") }}
          </span>
        </li>

        <li v-if="point.schedulerJob">
          <span style="font-size: 10px; color: rgb(128, 128, 128)">{{
            $t("point.lastRun")
          }}</span>
          <br />
          <span
            >~{{ formatDate(point.schedulerJob.lastRunAt, "past") }}
            {{ $t("common.minute") }} {{ $t("common.before") }}
            <el-tooltip placement="top">
              <em class="el-icon-info"></em>
              <div slot="content" v-if="point.schedulerJob">
                <span style="font-size: 10px; color: rgb(128, 128, 128)">{{
                  $t("point.lastFail")
                }}</span>
                <br />
                <span
                  >{{ formatDate(point.schedulerJob.failedAt, "past") }}
                  {{ $t("common.minute") }} {{ $t("common.before") }}</span
                >
                <br />
                <span style="font-size: 10px; color: rgb(128, 128, 128)">{{
                  $t("point.failReason")
                }}</span>
                <br />
                <span v-if="point.schedulerJob.failReason">{{
                  point.schedulerJob.failReason
                }}</span>
              </div>
            </el-tooltip>
          </span>
        </li>
      </ul>
      <el-form
        v-if="editing"
        label-position="top"
        label-width="100px"
        :model="form"
        ref="form"
        :rules="rules"
      >
        <el-row>
          <el-form-item :label="$t('point.sleepAmount')">
            <el-select v-model="form.sleepAmount" placeholder="Select">
              <el-option
                v-for="item in configurations.sleepAmounts"
                :label="$t(`sleepAmount.${item.friendly}`)"
                v-bind:key="item.index"
                :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-button
          v-if="checkPermission('updatePointConfig')"
          size="mini"
          @click="save()"
          >{{ $t("point.save") }}</el-button
        >
        <el-button size="mini" @click="editing = false">{{
          $t("point.cancel")
        }}</el-button>
        <el-button
          v-if="checkPermission('deletePointConfig') && point.periodic"
          size="mini"
          style="float: right"
          type="danger"
          @click="deleteIt()"
          >{{ $t("common.delete") }}</el-button
        >
      </el-form>
    </div>
    <br />
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import dayjs from "dayjs-ext";
export default {
  name: "Periodic",
  props: ["point"],
  data() {
    return {
      // showEditProfile: false
      bodyStyle: {
        padding: "5px",
      },
      loading: false,
      form: {
        sleepAmount: "",
      },
      editing: false,
      rules: {
        sampleSize: [
          {
            required: true,
          },
        ],
      },
    };
  },
  created() {},
  computed: {
    ...mapState("deviceConfigurations", ["configurations"]),
  },
  methods: {
    formatDate(value, direction) {
      let d = dayjs(value).diff(dayjs(), "m");
      return direction == "past" ? -1 * d : d;
    },
    ...mapActions("point", ["updatePeriodic", "deletePeriodic"]),
    deleteIt() {
      this.loading = true;
      this.$confirm(this.$t("point.areYouSure?"), this.$t("point.warning"), {
        confirmButtonText: this.$t("point.ok"),
        cancelButtonText: this.$t("point.cancel"),
        type: "warning",
      })
        .then(() => this.deletePeriodic(this.point._id))
        .then(() => {
          this.loading = false;
          this.editing = false;
          this.$message({
            type: "success",
            message: this.$t("point.DeleteCompleted"),
          });
        })
        .finally(() => (this.loading = false));
    },
    save() {
      this.loading = true;
      this.updatePeriodic({
        pointId: this.point._id,
        periodic: this.form,
      })
        .then(() => {
          this.editing = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    showEditForm() {
      if (this.point.periodic) {
        this.form = {
          sleepAmount: this.point.periodic.sleepAmount,
        };
      } else {
        this.form = {
          sleepAmount: this.configurations.sleepAmounts[0],
        };
      }
      this.editing = true;
    },
  },
};
</script>
<style>
.periodic .el-form--label-top .el-form-item__label {
  padding-bottom: 0px;
}
.periodic .el-input-number__increase {
  right: -19px;
}
.periodic .el-form-item__label {
  line-height: 0px;
  font-size: 12px;
}
.periodic .el-form-item {
  margin-bottom: 18px;
}

.periodic .el-input {
  width: 200px;
}

.info {
  padding: 10px;
  color: #232323;
  font-style: italic;
  font-size: 10px;
}
.point .el-card__header {
  padding: 10px;
}
</style>
<style  scoped>
.periodic .header:hover .edit,
.el-card__header:hover .edit {
  opacity: 1;
}
.edit {
  display: inline-block;
  opacity: 0.5;
}
.periodic {
  padding: 10px;
}
.periodic .body li {
  list-style-type: none;
  margin-bottom: 10px;
}
.periodic .header {
  font-size: 14px;
  padding-bottom: 5px;
  border-bottom: 1px solid rgb(226, 226, 226);
}
.path {
  margin-left: 5px;
  line-height: -20px;
  font-size: 12px;
  color: gray;
}
.name {
  font-size: 20px;
  font-weight: bold;
}
.point {
  margin-bottom: 10px;
}
</style>